// apiNotiUpdate.ts

import {
    ApiUserNotiUpdateReqSchema,
    ApiUserNotiUpdateResSchema,
} from "@bridge-applications/eh-types";
import { z } from "zod";
import { API_BASE } from "../state/config";

export const apiNotiUpdate = async (
    newNotiEnabled: boolean,
    accessToken: string,
) => {
    try {
        const payload: z.infer<typeof ApiUserNotiUpdateReqSchema> = {
            enabled: newNotiEnabled,
        };
        const res = await fetch(`${API_BASE}/api/v1/user/noti-update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
        });
        const resData = await res.json();
        if (res.ok) {
            const parsedResData = ApiUserNotiUpdateResSchema.safeParse(resData);
            if (parsedResData.success) {
                return parsedResData.data;
            } else {
                throw new Error(parsedResData.error.message);
            }
        } else {
            throw new Error(resData.message);
        }
    } catch (e) {
        console.error(e);
        throw e;
    }
};
